"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../../Button"));

function template() {
  var _this$props = this.props,
      children = _this$props.children,
      elementRef = _this$props.elementRef,
      attribute = _this$props.attribute,
      multiple = _this$props.multiple,
      size = _this$props.size,
      accept = _this$props.accept,
      rest = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "elementRef", "attribute", "multiple", "size", "accept"]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    onClick: this.handleButtonClick
  }), children), _react["default"].createElement("label", {
    htmlFor: this.inputId,
    style: {
      display: 'none'
    },
    ref: this.labelRef
  }), _react["default"].createElement("input", {
    multiple: multiple,
    size: size,
    accept: accept,
    style: {
      display: 'none'
    },
    "data-qa-node": attribute,
    type: "file",
    onChange: this.handleInputChange,
    ref: elementRef,
    id: this.inputId
  }));
}